export default (text: string) => {
  const styleString = new RegExp(/\s*style="(.*)"/g);
  const styleTag = new RegExp(/<\s*style[^>]*>(.*?)<\s*\/\s*style>/g);
  return text.replace(styleString, '').replace(styleTag, '');
};
